export interface ILocalizeInjector {
  interpolate: (id: string, data?: Record<string, unknown>) => string;
}

interface WebmoduleComponentsState {
  componentslocalizeInjector?: ILocalizeInjector;
}

// Provide a typed handle to globalThis without suppressing errors.
function globalState(): WebmoduleComponentsState {
  const g = globalThis as { webmoduleComponents?: WebmoduleComponentsState };
  if (!g.webmoduleComponents) {
    g.webmoduleComponents = {};
  }
  return g.webmoduleComponents;
}

export function setLocalizeInjector(injector: ILocalizeInjector): void {
  if (!injector || typeof injector.interpolate !== 'function') {
    throw new Error('Invalid localize injector provided');
  }
  const state = globalState();
  state.componentslocalizeInjector ??= injector;
}

export function getLocalizeInjector(): ILocalizeInjector {
  const state = globalState();
  if (!state.componentslocalizeInjector) {
    throw new Error('Localize injector is not set');
  }
  return state.componentslocalizeInjector;
}
